module.exports = __webpack_public_path__ + "media/images/img_copy_button-116473bb.png";